// hooks/useCurrentUserContext.js

import { useContext } from "react";
import { CurrentUserContext } from "../context/CurrentUserContext";

const useCurrentUserContext = () => useContext(CurrentUserContext);

export default useCurrentUserContext;
